import { get, set } from "lodash-es";
import { ClientService } from "../../services/client.service";

export abstract class BaseClientRepository<T> {
  constructor(
    protected clientService: ClientService,
    protected accessor: string,
  ) {}

  public get(): T {
    const clientData = this.clientService.currentClient()?.clientData;
    return get(clientData, this.accessor);
  }

  public async set(value: T): Promise<T> {
    const client = await this.clientService.getCurrentClientSafe();
    const newClientData = set(client.clientData, this.accessor, value);
    await this.clientService.setCurrentClient({
      ...client,
      clientData: newClientData,
    });
    return value;
  }

  public async clear(): Promise<void> {
    const client = await this.clientService.getCurrentClientSafe();
    const newClientData = set(client.clientData, this.accessor, undefined);
    await this.clientService.setCurrentClient({
      ...client,
      clientData: newClientData,
    });
  }
}
